module.exports = __webpack_public_path__ + "static/media/search2.afc8a3f6.svg";